/*路由语言*/
// src/locales/zh-CN.js

export default {
  //路由语言
  'home.title': 'CTM看世界',
  'detail.title': '详情',
  'shareDetail.title': '分享页',
  'filter.title': '筛选',
  'special.title': '专题',
  'search.title': '搜索',
  'activity.title': '活动',

  //首页语言
  'home.page.more': '更多',
  'home.page.hot': '热点推荐',
  'home.page.good': '最热最新',

  //搜索页语言
  'search.page.cancel': '取消',
  'search.page.placeholder': '请输入片名、主演或导演',
  'search.page.searchToast1': '未搜索到相关内容',
  'search.page.searchToast2': '请换个词再试试吧',
  'search.page.searchhistory': '搜索历史',
  'search.page.hotSearch': '热门搜索',
  'filter.page.failToast': '无筛选结果',
  'search.page.address': '地区',
  'search.page.act': '主演',
  'search.page.from': '来源',
  'search.page.year': '年份',
  'search.page.mangguo': '芒果TV',
  'search.page.hmvod': 'HMVOD',

  //详情语言
  'detail.page.share': '分享',
  'detail.page.summary': '简介  ',
  'detail.page.selection': '选集',
  'detail.page.selections': '全部选集',
  'detail.page.recommend': '为您推荐',
  'detail.page.watchingHorror': '看正片',
  'detail.page.scanQR': '请扫描二维码下载客户端观看',
  'detail.page.Android': '安卓下载',
  'detail.page.IOS': 'IOS下载',
  'detail.page.next': '播放下一个',
  'detail.page.age': '适龄年龄',
  'detail.page.Playability': '输入设备',
  'detail.page.Players': '玩家数',
  'detail.page.Availability': '可玩平台',
  'detail.page.ReadMore': '查看更多',
  'detail.page.PlayGame': '开始游戏',

  //播放器提示语言
  'video.page.vodFailToast': '该资产无法播放，换个资产试试看吧',

  // 收藏
  'collect.page.myCollect': '我的收藏',
  'collect.page.view': '最近观看',
  'collect.page.viewRecord': '观看记录',
  'collect.page.noView': '暂无最近观看内容',
  'collect.page.noCollect': '暂无收藏记录',
  'collect.page.clear': '清空记录',
  'collect.page.collect': '收藏',
  'collect.page.cancelCollect': '取消收藏',
  'collect.page.movie': '电影',
  'collect.page.series': '电视剧',
  'collect.page.news': '资讯',
  'collect.page.column': '综合类型',
  'collect.page.category': '专题',
  'collect.page.today': '今日',
  'collect.page.yesterday': '昨日',
  'collect.page.beforeYesterday': '前日',
  'collect.page.earlier': '更早',
  'collect.page.part': '部',
  'collect.page.clearView': '确认清空最近观看记录吗',
  'collect.page.clearCollect': '确认清空收藏记录吗',
  'collect.page.clearSuccess': '记录清除成功',
  'collect.page.oneClearSuccess': '已取消',
  'collect.page.oneCollectSuccess': '已收藏',
  'collect.page.CollectSpecial': '收藏专题',

  // 个人中心
  'profile.page.profile': '个人中心',
  'profile.page.cut': '切换账号',
  'profile.page.logout': '登出账号',
  'profile.page.login': '立即登录',
  'profile.page.bill': '账单',
  'profile.page.equity': '权益',
  'profile.page.download': '下载 CTM Home Media 应用程序',
  'profile.page.lang': '语言切换',
  'profile.page.patriarch': '家长管制',
  'profile.page.type': '类别',
  'profile.page.title': '名称',
  'profile.page.time': '订单时间',
  'profile.page.payTime': '购买时间',
  'profile.page.validTime': '有效期',
  'profile.page.price': '购买价格',
  'profile.page.none': '暂无数据',
  'profile.page.open': '（已开启)',
  'profile.page.closed': '(已关闭)',
  'profile.page.mumber': '会员',
  'profile.page.ticket': '电影券',
  'profile.page.Tip1': ' 注：月費支付的會員有效期直到取消服務爲止',

  // 登陸
  'login.page.phone': '手机号码登录/注册',
  'login.page.verify': '去验证',
  'login.page.qrcode': '请使用 CTM Home Media 手机应用程序扫码登陆',
  'login.page.back': '返回',
  'login.page.sureLogin': '确认登陆',
  'login.page.verification': '请输入验证码完成登录/注册',
  'login.page.check': '安全校验',
  'login.page.answer': '请填写正确答案已完成校验',
  'login.page.sure': '确认',
  'login.page.next': '换一张',
  'login.page.require': '重新验证',
  'login.page.please': '请输入正确的手机号',
  'login.page.loginSuccess': '登陆成功',
  'login.page.pleaseCode': '请输入验证码',
  'login.page.pleaseTrueCode': '请输入正确的验证码',
  'login.page.pleaseImgVerify': '请输入图片验证码结果',
  'login.page.pleaseTrueImgVerify': '请输入正确的图片验证码结果',
  'login.page.openordownload': '下载/打开',
  'login.page.clickRight': '请点击右上角，选择在浏览器中打开链接',

  // 订购
  'order.page.QRpayType': '扫码支付平台',
  'order.page.QRtips':
    '扫码支付提示：1.成功付款后服务随即生效；2.首月服务计划有效期为30日',
  'order.page.QRpay': '二维码支付',
  'order.page.paySuccess': '订购成功',
  'order.page.paySuccess1': '成功，您已完成会员权益的订购',
  'order.page.paySuccess2': '尊敬的会员，您好',
  'order.page.paySuccess3':
    ' 您可在“我的”权益中心查看您订购的权益，享受会员服务过程中如有问题可联系客服1000',
  'order.page.selfRecovery': '后自动返回',
  'order.page.payfaile1': '未能成功购买',
  'order.page.payfaile2': '抱歉，订购过程中遇到问题，订购失败',
  'order.page.warnCode': '错误码',
  'order.page.payfaile3': '1. 请您选择其他节目或重新刷新再次尝试',
  'order.page.payfaile4': ' 2. 如以上方法均无法解決，请拨打 1000 进行咨询。',
  'order.page.payfaile3005':
    '您的会员权益正在处理，如有需要，可联系客服电话1000',
  'order.page.payfaile3006': ' 您的会员权益正在处理中，请稍候',
  'order.page.close': '关闭',
  'order.page.getCode': '获取验证码',
  'order.page.getCodeAgain': '重新获取验证码',
  'order.page.payVerify': '支付验证',
  'order.page.billPay': '流动账单支付',
  'order.page.payCode': '支付账号',
  'order.page.order': '订购',
  'order.page.pleaseDuCode': '请输入DU账号',
  'order.page.pleaseID': '请输入身份ID',
  'order.page.InternetOrder': '互联网账单支付',
  'order.page.pleaseDu': '请输入服务DU',
  'order.page.ID': '身份ID',
  'order.page.ordering': '订购中，请稍后',
  'order.page.WXPC': '工银澳门-微信PC',
  'order.page.developing': '开发中',
  'order.page.purchaseType': '选择购买类型',
  'order.page.paymentType': '请选择支付方式',
  'order.page.viewService': '查看服务条款与细则',
  'order.page.Tip1': '购买即同意上述《服务条款与细则》',
  'order.page.Tip2': '本服务之条款及细则（「本条款及细则」）',

  // 首页语言
  'home.page.lodin': '您已登录',
  'home.page.day': '天',

  //  Toast
  'toast.page.processed': '您所申请的服务正在处理中，请稍后再试',

  // 筛选
  'filter.page.all': '全部',
  'filter.page.open': '最近打开',
  'filter.page.collect': '我的收藏',

  // 家长管制
  'parent.page.set': '设置家长管制',
  'parent.page.num': '账号',
  'parent.page.code': '手机验证码',
  'parent.page.setPassword': '设置家长管制密码',
  'parent.page.pleasePIN': '请输入密码',
  'parent.page.getCode': '获取验证码',
  'parent.page.wrongPassword': '密码错误',
  'parent.page.notice': '注意',
  'parent.page.Tip1':
    '本物品内容可能令人反感; 不可将本物品派发、传阅、出售、出租、交给或出借予年龄未满18岁的人士或将本物品向该等人士出示、播放或放映您需要开启管制才能继续观看该内容。 ',
  'parent.page.verify': '验证',
  'parent.page.close': '关闭家长管制',
  'parent.page.open': '开启家长管制',
  'parent.page.onmsg': '家长管制已开启',
  'parent.page.offmsg': '家长管制已关闭',
  'parent.page.pleaseOpen': '请先开启家长管制',
  'parent.page.changePassword': '修改密码',

  // HMOVD
  'hmovd.page.member': '会员无限睇',
  'hmovd.page.ticket': '电影券',
  'hmovd.page.use': '本次使用',
  'hmovd.page.have': '拥有',
  'hmovd.page.piece': '张',
  'hmovd.page.validity': '有效期',
  'hmovd.page.Tip1': '观影劵不足，需要购买观影劵',
  'hmovd.page.Tip2': '购买使用后 48 小时内有效，可重看',
  'hmovd.page.Tip3': '所有额外赠送观影劵使用期限到取消服务为止',
  'hmovd.page.Tip4': '支付成功，请在48小时内观看',
  'hmovd.page.exchange': '立即兑换',
  'hmovd.page.buy': '立即购买',
  'hmovd.page.surplus': '电影券剩余',
  'hmovd.page.please': '请使用观影劵观看内容',
  'hmovd.page.need': '需要购买后才可观看',
  'hmovd.page.look': '电影券观看',
  'hmovd.page.purchase': '购买',

  //mytv
  'mytv.page.playNow': '立即播放',
  'mytv.page.firstTimeWatch': '首次观看myTV内容需添加Email账号',
  'mytv.page.account': '账号',
  'mytv.page.emailAddress': 'Email地址',
  'mytv.page.phoneNumberVerification': '流动电话验证码',
  'mytv.page.retryAfter': '后重新获取',
  'mytv.page.getVerificationCode': '获取验证码',
  'mytv.page.emailNotice':
    '注意：Email地址与会员权益相关，一经设置不可自行修改，更换Email账号有可能影响已购会员权益',
  'mytv.page.confirm': '确认',
  'mytv.page.cancel': '取消',
  'mytv.page.confirmLater': '后可确认',
  'mytv.page.confirmEmailAddress': '确认Email账号',
  'mytv.page.enterEmailAddress': '您要绑定的Email账号',
  'mytv.page.emailBindingSuccess': '绑定成功',
  'mytv.page.enterValidEmailAddress': '请输入正确的Email账号',
  'mytv.page.enterVerificationCode': '请输入验证码',
  'mytv.page.enterEmailAddressPrompt': '请输入Email账号',
  'mytv.page.bindEmail': '添加邮箱地址',
};
